import CloseIcon from '@mui/icons-material/Close';
import { Modal, IconButton } from '@mui/material';
import React, { useState } from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ListingById } from '../../types/General';

type props = {
  details: ListingById | undefined;
};
const ImageGallery = ({ details }: props) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);

  const handleOpenModal = (index: number) => {
    setSelectedImageIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedImageIndex(null);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: selectedImageIndex ?? 0,
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '10px',
        padding: '20px',
      }}
    >
      {details?.image?.length ? (
        details?.image?.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Car ${index}`}
            style={{
              width: '100%',
              height: '150px',
              objectFit: 'cover',
              cursor: 'pointer',
              borderRadius: '8px',
            }}
            onClick={() => handleOpenModal(index)}
          />
        ))
      ) : (
        <p style={{ textAlign: 'center' }}>No images found</p>
      )}

      {/* Modal for Image Slider */}
      <Modal open={selectedImageIndex !== null} onClose={handleCloseModal}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'rgba(0,0,0,0.8)',
            position: 'relative',
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleCloseModal}
            style={{
              position: 'absolute',
              top: 20,
              right: 20,
              color: 'white',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* Slick Slider */}
          <div style={{ width: '80%', maxWidth: '600px' }}>
            <Slider {...sliderSettings}>
              {details?.image?.length
                ? details?.image?.map((img, index) => (
                    <div key={index}>
                      <img
                        src={img}
                        alt={`Car ${index}`}
                        style={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: '8px',
                        }}
                      />
                    </div>
                  ))
                : null}
            </Slider>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ImageGallery;
